/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type MentorSignupForShiftMutationVariables = Types.Exact<{
  shift_id: Types.Scalars["Float"];
}>;

export type MentorSignupForShiftMutation = {
  mentorSignupForShift: Pick<Types.ShiftSignup, "shift_id">;
};

export const MentorSignupForShiftDocument = gql`
  mutation MentorSignupForShift($shift_id: Float!) {
    mentorSignupForShift(shift_id: $shift_id) {
      shift_id
    }
  }
`;

/**
 * __useMentorSignupForShiftMutation__
 *
 * To run a mutation, you first call `useMentorSignupForShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMentorSignupForShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mentorSignupForShiftMutation, { data, loading, error }] = useMentorSignupForShiftMutation({
 *   variables: {
 *      shift_id: // value for 'shift_id'
 *   },
 * });
 */
export function useMentorSignupForShiftMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    MentorSignupForShiftMutation,
    MentorSignupForShiftMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    MentorSignupForShiftMutation,
    MentorSignupForShiftMutationVariables
  >(MentorSignupForShiftDocument, baseOptions);
}
export type MentorSignupForShiftMutationHookResult = ReturnType<
  typeof useMentorSignupForShiftMutation
>;
export type MentorSignupForShiftMutationResult =
  ApolloReactCommon.MutationResult<MentorSignupForShiftMutation>;
export type MentorSignupForShiftMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    MentorSignupForShiftMutation,
    MentorSignupForShiftMutationVariables
  >;
